// depends on jquery.spin plugin
export class KidsAjaxMonitor {
	constructor() { }
	static init() {
		KidsAjaxMonitor.createElement();
	}
	static createElement(speed) {
		KidsAjaxMonitor.element = $('<div></div>');
		KidsAjaxMonitor.element
			.css({
				'height': 0,
				'width': 0,
				'color': '000',
				'position': 'absolute',
				'bottom': 13,
				'right': 15,
				'z-index': 9999,
				'display': 'none'
			})
			.appendTo("body")
			.spin(
				$.extend(
					{
						lines: speed
					},
					KidsAjaxMonitor._spinnerSettings
				)
			);
			$(document).on("ajaxStart", function () {
				KidsAjaxMonitor.showAjaxLoader();
			}).on("ajaxStop", function () {
					KidsAjaxMonitor.hideAjaxLoader();
			});
	}
	static showAjaxLoader() {
		KidsAjaxMonitor._showCount += 1;

		KidsAjaxMonitor.element.show();
	}
	static hideAjaxLoader() {
		KidsAjaxMonitor._showCount -= 1;

		if (KidsAjaxMonitor._showCount <= 0) {
			KidsAjaxMonitor.element.hide();
		}
	}
}

KidsAjaxMonitor.element = null;

KidsAjaxMonitor._showCount = 0;

KidsAjaxMonitor._currentSpeed = 0;

KidsAjaxMonitor._lastStart = 0;

KidsAjaxMonitor._spinnerSettings = {
	lines: 10, // The number of lines to draw
	length: 4, // The length of each line
	width: 2, // The line thickness
	radius: 3, // The radius of the inner circle
	corners: 1, // Corner roundness (0..1)
	rotate: 0, // The rotation offset
	color: '#000', // #rgb or #rrggbb
	speed: 2.2, // Rounds per second
	trail: 64, // Afterglow percentage
	shadow: false, // Whether to render a shadow
	hwaccel: false, // Whether to use hardware acceleration
	className: 'spinner', // The CSS class to assign to the spinner
	zIndex: 2e9, // The z-index (defaults to 2000000000)
	top: 'auto', // Top position relative to parent in px
	left: 'auto' // Left position relative to parent in px
};

KidsAjaxMonitor.ImageUrl = '/Assets/images/site-ajax-indicator.gif';





